import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, n = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  d: "M16.19 2.169H7.81C4.17 2.169 2 4.339 2 7.979v8.37c0 3.65 2.17 5.82 5.81 5.82h8.37c3.64 0 5.81-2.17 5.81-5.81v-8.38c.01-3.64-2.16-5.81-5.8-5.81M12 16.049c-2.14 0-3.88-1.74-3.88-3.88s1.74-3.88 3.88-3.88 3.88 1.74 3.88 3.88-1.74 3.88-3.88 3.88m5.92-9q-.075.18-.21.33-.15.135-.33.21a.995.995 0 0 1-1.09-.21q-.135-.15-.21-.33a1 1 0 0 1-.08-.38c0-.13.03-.26.08-.38.05-.13.12-.23.21-.33.23-.23.58-.34.9-.27.07.01.13.03.19.06q.09.03.18.09c.05.03.1.08.15.12.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38"
}, null, -1), r = [
  n
];
function s(l, a) {
  return e(), t("svg", c, [...r]);
}
const d = { render: s };
export {
  d as default,
  s as render
};
